import React from 'react';
import PropTypes from 'prop-types';

import ComponentType from 'common/src/app/data/enum/ComponentType';
import { withFunctionalClassName } from 'common/src/app/util/componentClassNameUtils';
import ImagePropTypes from 'common/src/app/util/proptypes/ImagePropTypes';
import Pages from 'common/src/app/data/enum/Pages';

import Wrapper from 'components/atoms/Wrapper';
import Row from 'components/atoms/Row';
import SlimmingWorldLogo from 'components/atoms/SlimmingWorldLogo';
import Image from 'components/atoms/Image';

import './account-login.scss';

const AccountLogin = ({ children, location, background }, {}, className) => (
  <div className={className}>
    <Image isBackgroundImage isLazy={false} {...background}>
      <Wrapper width="sm">
        <Row column className="main-content">
          <div className="main-content-wrapper">
            {React.cloneElement(children, { key: location.pathname })}
            <Row justifycenter className="main-content-footer">
              <SlimmingWorldLogo link="/" />
            </Row>
          </div>
        </Row>
      </Wrapper>
    </Image>
  </div>
);

AccountLogin.propTypes = {
  background: ImagePropTypes,
  children: PropTypes.node,
  location: PropTypes.objectOf(PropTypes.any),
};

export default withFunctionalClassName(ComponentType.PAGE, 'AccountLogin', [
  {
    'no-scroll': ({ location }) => location.pathname === Pages.LOGOUT,
  },
])(AccountLogin);
